<template>
  <v-dialog
    :value="value"
    v-on:input="$emit('input', $event)"
    persistent
    max-width="460"
  >
    <v-card>
      <v-card-title class="headline justify-center">
        <span>{{ $t("create-user-title") }}</span>
      </v-card-title>
      <v-divider />
      <v-card-text class="mt-4">
        <v-row>
          <v-col class="py-0 mt-2">
            <v-row>
              <label for="email">{{ $t("email-address-title") }}</label>
              <v-text-field
                id="email"
                v-model.trim="email"
                class="max-width-3"
                :error-messages="emailErrors"
                @input="$v.email.$touch()"
                @blur="blurTrim"
                required
                dense
                :key="emailKey"
                outlined
                autofocus
              />
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="handleHiddenDialog">キャンセル</v-btn>
        <v-btn
          color="primary"
          class="font-weight-bold"
          :loading="loaddingAddUser"
          @click="addUser"
          >登録</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import mixin from "@/mixin";
import { createUser } from "@/api/User.api";
export default {
  props: ["value"],
  mixins: [mixin.Auth, mixin.ValidateCreate],
  data() {
    return {
      username: "",
      email: "",
      emailKey: 0,
      loaddingAddUser: false,
    };
  },
  methods: {
    async addUser() {
      const { email } = this;
      this.loaddingAddUser = true;
      this.$v.$touch();
      if (!this.$v.$anyError) {
        var password = this.generatePassword();
        await this.handleSignUpUser(email, password, email, "User")
          .then(async (data) => {
            let params = {
              username: data,
              email,
              password,
            };
            await createUser(params)
              .then(() => {
                this.$emit("resetList");
              })
              .catch((err) => {
                console.log("err: ", err);
                // this.$toast.error(err);
              });
          })
          .catch((err) => {
            // console.log("err: ", err);
            const { code } = err;
            if (code == "UsernameExistsException") {
              this.$toast.error("メールアドレスはすでに存在します。");
            }
          });
      }
      this.loaddingAddUser = false;
    },
    blurTrim() {
      this.email.trim();
      this.emailKey++;
    },
    generatePassword() {
      let charset =
          "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
      for (var i = 0, n = charset.length; i < 10; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      return retVal;
    },
    handleHiddenDialog() {
      this.$v.$reset();
      this.$emit("input", false);
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  min-width: 130px;
  margin-top: 10px;
  font-weight: bold;
}
</style>